const IdiotScoresActionTypes = {
  GET_IDIOTSCORES_START: 'GET_IDIOTSCORES_START',
  GET_IDIOTSCORES_SUCCESS: 'GET_IDIOTSCORES_SUCCESS',
  GET_IDIOTSCORES_FAILURE: 'GET_IDIOTSCORES_FAILURE',
};

export default IdiotScoresActionTypes;
